"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MultiRegistrationSchema = void 0;
exports.MultiRegistrationSchema = {
  type: 'object',
  required: ['multiregistration_type'],
  additionalProperties: false,
  properties: {
    multiregistration_type: {
      type: 'string',
      enum: ['ticket', 'group']
    },
    multiregistration_limit: {
      type: 'number'
    },
    multiregistration_limit_field_id: {
      type: ['string', 'null']
    },
    mainparticipant_assigned_required: {
      type: 'boolean'
    },
    unassigned_tickets_allowed: {
      type: 'boolean'
    },
    subparticipant_form_field_ids: {
      type: 'array',
      items: {
        type: 'string'
      }
    },
    mainparticipant_confirmation_email_campaign_id: {
      type: ['string', 'null']
    },
    subparticipant_confirmation_email_campaign_id: {
      type: ['string', 'null']
    },
    mainparticipant_registration_pending_stage_name: {
      type: 'string'
    },
    mainparticipant_registration_completed_stage_name: {
      type: 'string'
    },
    subparticipant_registration_pending_stage_name: {
      type: 'string'
    },
    subparticipant_registration_completed_stage_name: {
      type: 'string'
    },
    cancellation_workflow_id: {
      type: ['string', 'null']
    },
    next_workflow_ids: {
      type: 'object',
      required: ['next_workflow', 'subparticipant_workflow'],
      additionalProperties: false,
      properties: {
        next_workflow: {
          type: ['string', 'null']
        },
        subparticipant_workflow: {
          type: ['string', 'null']
        }
      }
    }
  }
};
